import { type FC, useCallback } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";
import { formatNumberByThousands } from "widgets/utils";

import { pluralizeWord } from "../../../app-utils/string.js";
import { type Marker, type Region } from "../../../graphql.js";
import { TRACK_TYPE } from "../../../settings/settings.js";
import { ContigTile, GenomeViewTile } from "../../core/tiles/index.js";

export interface IRegionCardProps extends GridCard {
  entity: Marker;
  regions: Region[];
}

const RegionsOfContigCard: FC<IRegionCardProps> = ({ entity, regions }) => {
  // Create Genome View link depending the entity type
  const getGenomeViewLink = useCallback(
    (region: Region) => {
      const track = `${TRACK_TYPE.MARKER_NUS}@${entity.markerType.id}`;
      return `/contig/${region?.contig?.id}/genome?add_tracks=${track}&range=${region?.range?.start},${region?.range?.stop}`;
    },
    [entity],
  );

  return (
    <Card title={`${pluralizeWord("Location", regions?.length ?? 1)}`}>
      {regions.map((region) => (
        <CardRowSimple label={region.contig?.organism.name} key={`region-contig-${region.contig?.id}`}>
          <ContigTile contig={region?.contig} />
          <GenomeViewTile
            title={entity.name}
            to={getGenomeViewLink(region)}
            footNote={`with the '${entity.markerType?.name}' track`}
          >
            {formatNumberByThousands(region?.range?.start)} &ndash; {formatNumberByThousands(region?.range?.stop)} (
            {region.strand})
          </GenomeViewTile>
        </CardRowSimple>
      ))}
    </Card>
  );
};

export { RegionsOfContigCard };
